import Vue from "vue";
import Vuex from "vuex";
import schedules from "../../models/horarios/schedules";
import segments from "../../models/horarios/segments";
import service from "../../services/horarios/schedules";
import elements from "../../models/horarios/elements";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "300px",
    schedules: [],
    segments: [],
    segmentsAll: [],
    scheduleId: null,
    elements: [],
    segmentId: null,
    openSchedule: { type: "add", value: false },
    openSegment: { type: "tree", value: false },
    openReuseSegment: { type: "tree", value: false },
    openElement: { type: "tree", value: false, itemId: null },
    newSchedule: {},
    newSegment: {},
    itemDelete: null,
    openDeleteSch: false,
    openDeleteSeg: false,
    openDeleteEle: false,
    mode: "Agregar horario",
    editSchedule: {},
    sequence: [],
    editSegment: {},
    newElement: {},
    editElement: {},
    showElementWindow: false,
    showSegmentWindow: false,
    showScheduleWindow: false,
    showAssistentWindow: false,
    showHolidaysWindow: false,
    showEmployeesWindow: false,
    showGroupsWindow: false,
    newScheduleAsistent: {},
    elementsAll: [],
  },

  mutations: {
    setElementsAll(state, data) {
      state.elementsAll = data;
    },
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setSchedules(state, data) {
      state.schedules = data;
    },
    setSegments(state, data) {
      state.segments = data;
    },
    setSegmentsAll(state, data) {
      state.segmentsAll = data;
    },
    setScheduleId(state, data) {
      state.scheduleId = data;
    },
    setElements(state, data) {
      state.elements = data;
    },
    setSegmentId(state, data) {
      state.segmentId = data;
    },
    setOpenSchedule(state, data) {
      state.openSchedule = data;
    },
    setOpenSegment(state, data) {
      state.openSegment = data;
    },
    setOpenReuseSegment(state, data) {
      state.openReuseSegment = data;
    },
    setOpenElement(state, data) {
      state.openElement = data;
    },
    setNewSchedule(state, data) {
      state.newSchedule = data;
    },
    setNewSegment(state, data) {
      state.newSegment = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setOpenDeleteSch(state, data) {
      state.openDeleteSch = data;
    },
    setOpenDeleteSeg(state, data) {
      state.openDeleteSeg = data;
    },
    setOpenDeleteEle(state, data) {
      state.openDeleteEle = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setEditItemsSchedule(state, data) {
      state.editSchedule = data;
    },
    setSequence(state, data) {
      state.sequence = data;
    },
    setEditSegment(state, data) {
      state.editSegment = data;
    },
    setEditElement(state, data) {
      state.editElement = data;
    },
    setNewElement(state, data) {
      state.newElement = data;
    },
    setShowElementWindow(state, data) {
      state.showElementWindow = data;
    },
    setShowSegmentWindow(state, data) {
      state.showSegmentWindow = data;
    },
    setShowScheduleWindow(state, data) {
      state.showScheduleWindow = data;
    },
    setShowAssistentWindow(state, data) {
      state.showAssistentWindow = data;
    },
    setShowHolidaysWindow(state, data) {
      state.showHolidaysWindow = data;
    },
    setShowGroupsWindow(state, data) {
      state.showGroupsWindow = data;
    },
    setShowEmployeesWindow(state, data) {
      state.showEmployeesWindow = data;
    },
    setNewScheduleAsistent(state, data) {
      state.newScheduleAsistent = data;
    },
  },
  actions: {
    async getSchedules(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSchedules();
          state.commit("setSchedules", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSegmentsAll(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSegmentsAll();
          state.commit("setSegmentsAll", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getSegments(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSegments(
            state.state.scheduleId,
          );
          state.commit("setSegments", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getElements(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getElements(
            state.state.segmentId,
          );
          state.commit("setElements", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getElementsAll(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getElementsAll();
          state.commit("setElementsAll", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async reuseElement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .reuseElement(state.state.newElement)
            .then(() => {
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newSchedule(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newSchedule(state.state.newSchedule)
            .then(({ data }) => {
              let item = state.state.newSchedule;
              let options = state.state.schedules;
              let newItem = schedules.fromJson({
                Nombre: item.name,
                HorarioId: data.horarioId,
              });
              options.push(newItem);
              state.commit("setSchedules", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newScheduleAsistent(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newScheduleAsistent(state.state.newScheduleAsistent)
            .then(({ data }) => {
              let item = state.state.newScheduleAsistent;
              let options = state.state.schedules;
              let newItem = schedules.fromJson({
                Nombre: item.nombreHorario,
                HorarioId: data.horarioId,
              });
              options.push(newItem);
              state.commit("setSchedules", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async addReuseSegment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .reuseSegment(state.state.newSegment)
            .then(() => {
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async newSegment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newSegment(state.state.newSegment)
            .then(({ data }) => {
              let item = state.state.newSegment;
              let options = state.state.segments;
              let newItem = segments.fromJson({
                horarioId: item.schedule,
                segmId: data.segmId,
                numSecuencia: item.sequence,
                nomSegm: item.name,
                dias: item.days,
                desplJornada: item.desplJor,
                tipoJornada: item.jor,
              });
              options.push(newItem);
              state.commit("setSegments", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newElement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newElement(state.state.newElement)
            .then(({ data }) => {
              let item = state.state.newElement;
              let options = state.state.elements;
              let newItem = elements.fromJson({
                elemId: data.elemId,
                nomElem: item.element,
                desde: item.from,
                hasta: item.to,
                tolEnt: item.entry,
                tolSal: item.exit,
                conceptoId: item.concept,
                nomConcepto: item.conceptName,
                mts: item.mts,
                fracRed: item.roundingFraction,
                porcen: item.porcentage,
                laboral: item.labor,
                aplNoFeriados: item.noHolidays,
                aplFeriados: item.holidays,
                segmId: item.segid,
              });

              options.push(newItem);
              state.commit("setElements", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteSchedule(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteSchedule(state.state.itemDelete.toString())
            .then(() => {
              let options = state.state.schedules;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setSchedules", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteSegmentRelation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteSegmentRelation(state.state.itemDelete)
            .then(() => {
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteSegment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteSegment(state.state.itemDelete)
            .then(() => {
              let options = state.state.segments;
              options = options.filter((option) => {
                return option.segmId != state.state.itemDelete;
              });
              state.commit("setSegments", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteElement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteElement(state.state.itemDelete)
            .then(() => {
              let options = state.state.elements;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setElements", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteElementRelation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteElementRelation(state.state.itemDelete)
            .then(() => {
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editSchedule(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editSchedule(state.state.editSchedule)
            .then(() => {
              let item = state.state.editSchedule;
              let options = state.state.schedules;
              options = options.map((option) => {
                if (option.id !== item.id) {
                  return option;
                }
                item = schedules.fromJson({
                  HorarioId: item.id,
                  Nombre: item.name,
                });
                return item;
              });

              state.commit("setSchedules", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async copySchedule(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .copySchedule(state.state.editSchedule)
            .then(async () => {
              let item = await state.state.service.getSchedules();
              state.commit("setSchedules", item);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editSegment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editSegment(state.state.editSegment)
            .then(() => {
              let item = state.state.editSegment;
              let options = state.state.segments;
              options = options.map((option) => {
                if (option.segmId !== item.segmId) {
                  return option;
                }
                item = segments.fromJson({
                  horarioId: item.schedule,
                  segmId: item.segmId,
                  numSecuencia: item.sequence,
                  nomSegm: item.name,
                  dias: item.days,
                  desplJornada: item.desplJor,
                  tipoJornada: item.jor,
                  elems: item.elements.map((element) => {
                    return {
                      elemId: element.id,
                      nomElem: element.name,
                      desde: element.from,
                      hasta: element.to,
                      tolEnt: element.tolEnt,
                      tolSal: element.tolSal,
                      conceptoId: element.conceptId,
                      nomConcepto: element.conceptName,
                      laboral: element.laboral,
                      aplFeriados: element.aplFeriados,
                      aplNoFeriados: element.aplNoFeriados,
                      mts: element.mts,
                      fracRed: element.fracRed,
                      porcen: element.porcen,
                      resto: element.resto,
                    };
                  }),
                });
                return item;
              });

              state.commit("setSegments", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    editSequence(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editSequence(state.state.editSegment)
            .then(() => {
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editElement(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editElement(state.state.editElement)
            .then(() => {
              let item = state.state.editElement;
              let options = state.state.elements;
              options = options.map((option) => {
                if (option.id !== item.id) {
                  return option;
                }
                item = elements.fromJson({
                  elemId: item.id,
                  nomElem: item.element,
                  desde: item.from,
                  hasta: item.to,
                  tolEnt: item.entry,
                  tolSal: item.exit,
                  conceptoId: item.concept,
                  nomConcepto: item.conceptName,
                  mts: item.mts,
                  fracRed: item.roundingFraction,
                  porcen: item.porcentage,
                  laboral: item.labor,
                  aplNoFeriados: item.noHolidays,
                  aplFeriados: item.holidays,
                });
                return item;
              });

              state.commit("setElements", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSequence(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSequence(
            state.state.scheduleId,
            state.state.segmentId,
          );
          state.commit("setSequence", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async handleShowWindow(state, type) {
      return new Promise(async (resolve, reject) => {
        try {
          switch (type) {
            case "schedule":
              state.state.showScheduleWindow = true;
              state.state.showElementWindow = false;
              state.state.showSegmentWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showGroupsWindow = false;
              break;

            case "element":
              state.state.showElementWindow = true;
              state.state.showScheduleWindow = false;
              state.state.showSegmentWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;

            case "segment":
              state.state.showSegmentWindow = true;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;
            case "assistent":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showAssistentWindow = true;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;
            case "holiday":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = true;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = false;
              break;
            case "groups":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = false;
              state.state.showGroupsWindow = true;
              break;
            case "employees":
              state.state.showSegmentWindow = false;
              state.state.showScheduleWindow = false;
              state.state.showElementWindow = false;
              state.state.showAssistentWindow = false;
              state.state.showHolidaysWindow = false;
              state.state.showEmployeesWindow = true;
              state.state.showGroupsWindow = false;
              break;
            default:
              break;
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
